import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Calendar, DollarSign, User, LogOut } from 'lucide-react';
import { useMediaQuery } from 'react-responsive';
import './Sidebar.css';

const Sidebar = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    const handleLogout = () => {
        if (window.confirm('Are you sure you want to logout?')) {
            const config = window.reactPress || window.rpVars || {};
            const siteUrl = config.api?.rest_url?.split('/wp-json')[0] || '/';
            window.location.href = siteUrl;
        }
    };

    if (isMobile) {
        return (
            <nav className="mobile-nav">
                <NavLink to="/" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                    <LayoutDashboard size={20} />
                    <span>Home</span>
                </NavLink>
                <NavLink to="/schedule" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                    <Calendar size={20} />
                    <span>Schedule</span>
                </NavLink>
                <NavLink to="/profile" className={({ isActive }) => `mobile-nav-item ${isActive ? 'active' : ''}`}>
                    <User size={20} />
                    <span>Profile</span>
                </NavLink>
                <button onClick={handleLogout} className="mobile-nav-item logout-btn-mobile">
                    <LogOut size={20} />
                    <span>Logout</span>
                </button>
            </nav>
        );
    }

    return (
        <aside className="sidebar">
            <div className="sidebar-header">
                <div className="logo-text">
                    <span className="logo-title">Safety Driver</span>
                    <span className="logo-subtitle">STUDENT PORTAL</span>
                </div>
            </div>

            <nav className="sidebar-nav">
                <NavLink to="/" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                    <LayoutDashboard size={20} />
                    <span>Dashboard</span>
                </NavLink>
                <NavLink to="/schedule" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                    <Calendar size={20} />
                    <span>Schedule</span>
                </NavLink>
                <NavLink to="/financials" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                    <DollarSign size={20} />
                    <span>Financials</span>
                </NavLink>
                <NavLink to="/profile" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                    <User size={20} />
                    <span>My Profile</span>
                </NavLink>
            </nav>

            <div className="sidebar-footer">
                <button onClick={handleLogout} className="nav-item logout-btn">
                    <LogOut size={20} />
                    <span>Logout</span>
                </button>
            </div>
        </aside>
    );
};

export default Sidebar;
